// extracted by mini-css-extract-plugin
export default {"main-card":"AppUserDetail_main-card__bUa1H"};